<base-section [index]="index" [section]="section">
  <div class="grid grid-section">
    <div class="content" *ngIf="sectionRendered.introduction || sectionRendered.title">
      <h2 class="h2" [innerHTML]="sectionRendered.title"></h2>
      <div class="introduction" [innerHTML]="sectionRendered.introduction"></div>
    </div>
  </div>
  <div class="grid grid-section md-grid-cols-4 gap-l currently-content-container">
    <div class="col-span-1 md-col-span-3">
      <div class="currently-pages-container">
        <div class="pages-title">
          <div class="buttons-group">
            <button class="button-item" [ngClass]="{'active':list.active}" *ngFor="let list of sectionRendered.pages_list" (click)="onActiveClick(list)" [innerHTML]="list.title"></button>
          </div>
          <ng-container *ngFor="let list of sectionRendered.pages_list">
            <a class="button" *ngIf="list.active && list.main_page" [routerLink]="[list.main_page]" i18n="@@SeeAll">Tout voir</a>
          </ng-container>
        </div>
        <ng-container *ngFor="let list of sectionRendered.pages_list">
          <div @toggleTrigger class="pages-container" [ngClass]="{'active':list.active}">
            <div  class="grid md-grid-cols-3 gap-l p-0 list-pages-container" >
              <tiny-post class="col-1" *ngFor="let page of list.subpages|tinyPostsFromIds:'include'|async" [post]="page"></tiny-post>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="col-span-1">
      <div class="currently-events-container">
        <div class="event-title gap-m">
          <div class="h5" i18n="@@EventsLoved">Évènements <br/> "coup de coeur"</div>
        </div>
        <div class="currently-events-items-container">
          <synapi-list-items class="events list-without-map list-bookmarks" [col]="1" [id]="sectionRendered.events_selection" [size]="2" [standalone]="true"></synapi-list-items>
        </div>
        <a class="button" *ngIf="sectionRendered.events_page" [routerLink]="[sectionRendered.events_page]" i18n="@@SeeAllEventsLoved">Tous les "coup de coeur"</a>
      </div>

    </div>
  </div>
</base-section>
